import React from 'react'
import {useSuspense} from '@data-client/react'
import {Trip, TripResource, TripsFilter} from '../lib/model'
import {EpicMap} from '../components/Map'
import {PageProps} from '../components/PageRouter'
import {ILatLng} from '@fotolog/data'
import {useWindowSize} from 'react-use'
import {useToggle} from '../lib'
import {DetailPanel} from '../components'
import {Box, Button, Container, Typography} from '@mui/material'
import {IconAdd, IconTripMap, IconFilters} from '../Icons'
import {useLocation} from 'wouter'
import {PrivateGlobeTrips, TripFilterForm} from '../components/Trip'

export default function GlobePage({session}: PageProps) {
  const {width} = useWindowSize()
  const [location] = useLocation()
  const detailing = location.match('/globe/trip/') // TODO: awkward coupling with route
  const right = detailing ? 400 : 0 // TODO: use PANEL_WIDTH constant
  const filters = useToggle(false)
  const [bounds, setBounds] = React.useState(JSON.parse(localStorage.getItem('trip.bounds') || 'null'))
  const onMap = (trip: Trip) => {
    const gps = trip.cover?.gps
    if (!bounds || !gps) {
      return true
    }
    const [bl, ur] = bounds
    return bl.lat <= gps.lat && gps.lat <= ur.lat && bl.lng <= gps.lng && gps.lng <= ur.lng
  }
  const onBoundsChange = (bl: ILatLng, ur: ILatLng) => {
    setBounds([bl, ur])
    localStorage.setItem('trip.bounds', JSON.stringify([bl, ur]))
  }
  const [qry, updateQry] = React.useState<TripsFilter>({scope: session.euid(), tags: []})
  const trips = useSuspense(TripResource.getList, qry)

  const onSearch = (data: TripsFilter) => {
    updateQry(data)
  }

  if (!trips) {
    return null
  }
  return (
    <Box position="fixed" top={80} left={0} bottom={0} right={right}>
      <EpicMap trips={trips} width={width - right} onBoundsChange={onBoundsChange} />
      {detailing || (
        <Container maxWidth="md" sx={{position: 'relative'}}>
          <Box className="app-flex" flexWrap="wrap" mt="10px" bgcolor="rgba(50, 50, 50, 0.5)" borderRadius={1}>
            <Typography variant="h3" color="secondary" p={1}>
              Trips
            </Typography>
            <Box className="app-flex" mr={3}>
              <Button title="List Trips" href="./trip/" color="primary" variant="contained" size="small">
                <IconTripMap />
              </Button>
              &nbsp;
              <Button title="Add Trip" href="./add-trip" color="primary" variant="contained" size="small">
                <IconAdd />
              </Button>
              &nbsp;
              <Button title="Filter Trips" onClick={filters.toggle} color="primary" variant="contained" size="small">
                <IconFilters />
              </Button>
            </Box>
          </Box>
          <TripFilterForm show={filters} onSearch={onSearch}/>
        </Container>
      )}
      <DetailPanel
        props={{trips: trips.filter(onMap)}}
        path="(?<home>/globe)/trip/(?<trip>\d+)?$"
        panel={PrivateGlobeTrips}
        title={['Globe', 'Matching Trips']}
        overlay={false}
      />
    </Box>
  )
}
